import HelpButton from './HelpButton';
// Staff form explanations participate in the universal Self-Help system too.
export default function HelpTip({ label, children }) {
    return <HelpButton title={label}>{children}</HelpButton>;
}
